import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import './LegalPages.css';

const Hakkimizda = () => {
  return (
    <Container maxWidth="md" className="legal-container">
      <Paper elevation={3} className="legal-paper">
        <Typography variant="h4" component="h1" gutterBottom>
          Hakkımızda
        </Typography>
        
        <Typography variant="body1" paragraph>
          HOPS, iş makinesi operatörlerinin puantaj işlemlerini dijitalleştirerek, sektörde devrim yaratan yenilikçi bir platformdur. 
          Kurulduğumuz günden bu yana, müşterilerimize en kaliteli ve güvenilir hizmeti sunmayı hedefledik.
        </Typography>

        <Typography variant="body1" paragraph>
          Misyonumuz, iş makinesi operatörlerinin ve şirketlerin puantaj süreçlerini kolaylaştırmak, 
          zaman ve maliyet tasarrufu sağlamak ve dijital dönüşüme katkıda bulunmaktır.
        </Typography>

        <Typography variant="body1" paragraph>
          Vizyonumuz, Türkiye'nin ve dünyanın önde gelen dijital puantaj platformu olmak ve 
          sektörde standartları belirleyen bir konuma ulaşmaktır.
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: '20px' }}>
          Değerlerimiz
        </Typography>

        <ul>
          <li>
            <Typography variant="body1">
              <strong>Güvenilirlik:</strong> Müşterilerimizin verilerinin güvenliği bizim için en önemli önceliktir.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Yenilikçilik:</strong> Sürekli gelişen teknolojileri takip eder ve sistemimizi güncel tutarız.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Müşteri Odaklılık:</strong> Müşterilerimizin ihtiyaçlarını anlar ve en iyi çözümleri sunarız.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Kalite:</strong> Her zaman en yüksek kalitede hizmet sunmayı taahhüt ederiz.
            </Typography>
          </li>
        </ul>

        <Typography variant="body1" paragraph style={{ marginTop: '20px' }}>
          HOPS olarak, müşterilerimize en iyi hizmeti sunmak için sürekli kendimizi geliştiriyor ve 
          yenilikleri takip ediyoruz. Sizin başarınız için çalışıyoruz.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Hakkimizda; 